import { useState } from 'react';
import { color } from '../../../app/theme';

const IconTableSortUp = ({ style = { marginRight: 4 } }) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <svg
      onMouseEnter={() => {
        setIsHover(true);
      }}
      onMouseLeave={() => {
        setIsHover(false);
      }}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      style={style}
    >
      <g fill="none">
        <path
          fill={isHover ? color.$10 : color.$3}
          d="M11.416 6.653a.659.659 0 0 0 .858-1L8.43 2.359a.659.659 0 0 0-.858 0L3.73 5.653a.659.659 0 0 0 .858 1l3.414-2.926 3.414 2.926z"
        />
        <path
          fill={isHover ? color.$10 : color.$9}
          d="M11.416 9.349a.659.659 0 1 1 .858 1L8.43 13.643a.659.659 0 0 1-.858 0L3.73 10.35a.659.659 0 1 1 .858-1l3.414 2.926 3.414-2.926z"
        />
      </g>
    </svg>
  );
};

export default IconTableSortUp;
